export default "__VITE_ASSET__C388B4wQ__"